<div>
  <form [formGroup]="form">
    <ion-row>
      <!-- Customer name -->
      <ion-col size="2" class="col-label">
        {{ CONSTS.CUSTOMER_NAME }}
      </ion-col>
      <ion-col size="4" class="col-value">
        {{ data.customerName }}
      </ion-col>

      <!-- Contact Name -->
      <ion-col size="2" class="col-label">
        {{ CONSTS.CONTACT_NAME }}
      </ion-col>
      <ion-col size="4" class="col-value">
        {{ data.contactName }}
      </ion-col>
    </ion-row>

    <ion-row>
      <!-- Address -->
      <ion-col size="2" class="col-label">
        {{ CONSTS.STREET_ADDRESS }}
      </ion-col>
      <ion-col size="4" class="col-value">
        {{ data.streetAddress }}
      </ion-col>

      <!-- Phone Number -->
      <ion-col size="2" class="col-label">
        {{ CONSTS.CONTACT }}
      </ion-col>
      <ion-col size="4" class="col-value">
        {{ data.contact }}
      </ion-col>
    </ion-row>

    <ion-row>
      <!-- City -->
      <ion-col size="2" class="col-label">
        {{ CONSTS.CITY_TOWN }}
      </ion-col>
      <ion-col size="4" class="col-value">
        {{ data.cityTown }}
      </ion-col>

      <!-- Suite Number -->
      <ion-col size="2" class="col-label">
        {{ CONSTS.SUITE_FLOOR }}
      </ion-col>
      <ion-col size="4" class="col-value">
        @if (data.suite && !data.floor) {
          <span>{{ data.suite }} </span>
        }
        @if (data.floor && !data.suite) {
          <span>{{ data.floor }} </span>
        }
        @if (data.floor && data.suite) {
          <span>{{ data.suite }}/{{ data.floor }}</span>
        }
      </ion-col>
    </ion-row>

    <ion-row>
      <!-- Province -->
      <ion-col size="2" class="col-label">
        {{ CONSTS.PROVINCE }}
      </ion-col>
      <ion-col size="4" class="col-value">
        {{ data.province }}
      </ion-col>

      <!-- Pickup Location -->
      <ion-col size="2" class="col-label">
        {{ CONSTS.PICKUP_LOCATION }}
      </ion-col>
      <ion-col size="4" class="col-value">
        {{ data.pickupLocation }}
      </ion-col>
    </ion-row>

    <ion-row>
      <!-- Postal Code -->
      <ion-col size="2" class="col-label">
        {{ CONSTS.POSTAL_CODE }}
      </ion-col>
      <ion-col size="4" class="col-value">
        {{ data.postalCode }}
      </ion-col>

      <!-- Number Of Pkgs Location -->
      <ion-col size="2" class="col-label">
        {{ CONSTS.NUMBER_OF_PACKAGES }}
      </ion-col>
      <ion-col size="4" class="col-value">
        <a class="hyperlink" (click)="onClickNumberOfPackages()">
          {{ data.numberofPkgs }} >
        </a>
      </ion-col>
    </ion-row>

    <ion-row>
      <!-- Lat Long-->
      <ion-col size="2" class="col-label">
        {{ CONSTS.LATITUDE }} / {{ CONSTS.LONGITUDE }}
      </ion-col>
      <ion-col size="4" class="col-value"> {{ data.latLong }}</ion-col>

      <!-- SLIC -->
      <ion-col size="2" class="col-label">
        {{ CONSTS.SLIC }}
      </ion-col>
      <ion-col size="4" class="col-value">
        {{ data.slic }}
      </ion-col>
    </ion-row>
  </form>
</div>

<ng-template #numberOfPackagesDialog>
  <div class="number-of-packages-dialog">
    <button
      type="button"
      class="close-icon"
      aria-label="Close panel"
      (click)="closeNumberOfPackagesPanel()"
    >
      x
    </button>

    <div class="dialog-header-row">
      <span class="dialog-title">{{ CONSTS.NUMBER_OF_PACKAGES }} ({{ data.numberofPkgs }})</span>
      <input
        type="text"
        class="package-search-input"
        placeholder="Search packages"
        [(ngModel)]="packageSearchText"
      />
    </div>

    <div class="package-list">
      @for (pkg of filteredPackageList; track pkg) {
        <div class="package-row">{{ pkg }}</div>
      }
      @if (filteredPackageList.length === 0) {
        <div class="package-row no-results">No packages found</div>
      }
    </div>
  </div>
</ng-template>
